import '../ranking_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.UserRankingChartView extends Monitoring.Views.Charts.RankingChartView
  ranking_template: JST["backbone/templates/monitoring/charts/user_ranking"]
  className: 'chart-ranking user-ranking item h2'
  tabs: 1
  url: "/monitoring/dashboard/charts/users_by_status/"

  render: ->
    rank_title = ""
    rankings = @getRankingList()
    @$el.html(@generic_template({rankings:rankings,results:@defaultResults, rank_title}))
    for settings in rankings
      @getRankings(settings)


  getRankingList: ->
    [{ id:'user_ranking', title:I18n.t('monitoring.dashboard.charts.user_participation_ranking'), spanSize: '12' }]
